import { GridColDef } from '@mui/x-data-grid-premium';

export const conditionalGridColDefs = <T>(
  condition: boolean,
  column: GridColDef<T>,
): GridColDef<T>[] => {
  return condition ? [column] : [];
};
